<script>
    import {COUNTRY_CODES} from "../../lib/data.js";
    import {setFocusTo} from "../../lib/lib.js";
    import {createEventDispatcher} from "svelte/internal";

    export let value;
    export let id = 'phone';
    export let disabled = false;
    export let required = false;

    let code = '';
    let phone = '';

    const dispatch = createEventDispatcher();

    const onCodeChange = () => {
        onPhoneChange();
        if (id) {
            setFocusTo(id);
        }
    }

    const onPhoneChange = () => {
        if (code && phone) {
            dispatch("change", `${code}${phone}`.replace("+", ""));
        }
    }

    if (value) {
        phone = value.slice(-10);
        code = value.replace(phone, "");
        if (code) code = `+${code}`;
    }

    $: {
        if (code && phone) {
            value = `${code}${phone}`.replace("+", "");
        } else {
            value = '';
            // if (value && !phone) {
            //     phone = value.slice(-10);
            //     code = value.replace(phone, "");
            //     if (code) code = `+${code}`;
            // }
        }
    }
</script>

<div class="input-group">
    <div class="country-code pointer">
        <select class="form-select pointer" id="countryCodes" bind:value="{ code }" on:change={ onCodeChange }
                {required} {disabled}>
            <option value="" disabled="">Code</option>
            {#each COUNTRY_CODES as item}
                <option value="{ item.code }">{ item.name }</option>
            {/each}
        </select>
        <div class="btn btn-default">
            {#if code}
                { code }
            {:else}
                Code
            {/if}
        </div>
    </div>
    <input type="tel" class="form-control phone" {id} bind:value="{ phone }"
           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
           on:change={onPhoneChange}
           {required}>
</div>

<style>
    .country-code {
        position: relative;
        width: 55px;
    }

    .country-code .btn {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        /*border-top-left-radius: 0.375rem;*/
        /*border-bottom-left-radius: 0.375rem;*/
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        padding-left: 0;
        padding-right: 0;
        z-index: 1;
    }

    .country-code .form-select {
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
    }

    .phone {
        width: calc(100% - 140px);
    }
</style>
